import React, { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";

// ---- UI string dictionary (chrome / non-CMS strings) ----
export const UI = {
  de: {
    requestAppointment: "Termin anfragen",
    overview: "Übersicht",
    loading: "Wird geladen …",
    pageNotFound: "Seite nicht gefunden",
    newsNotFound: "News nicht gefunden",
    allNews: "Alle News",
    mainNav: "Hauptnavigation",
    mobileNavLabel: "Mobile Navigation",
    openMenu: "Menü öffnen",
    closeMenu: "Menü schließen",
    breadcrumb: "Breadcrumb",
    home: "Start",
    langAria: "Sprache wählen",
    // footer
    rightsReserved: "Alle Rechte vorbehalten.",
    imprint: "Impressum",
    privacy: "Datenschutz",
    cookieSettings: "Cookie-Einstellungen",
    // contact form
    cfQuickTitle: "Am schnellsten per WhatsApp oder E-Mail",
    cfQuickText: "Termin- und Kontaktanfragen — bitte nicht für Notfälle. Bei akuten Beschwerden: Notruf 112.",
    cfPrivateTitle: "Wichtiger Hinweis: privatärztliches Angebot",
    cfPrivateText: "Preventum Diez ist ein privatärztliches Angebot für Privatversicherte und Selbstzahler. Eine Abrechnung über die gesetzliche Krankenversicherung ist nicht möglich.",
    cfPrivateAck: "Ich habe verstanden, dass es sich um ein privatärztliches Angebot handelt und keine Abrechnung über die gesetzliche Krankenversicherung erfolgt. *",
    cfPrivateAckError: "Bitte bestätigen Sie den Hinweis zum privatärztlichen Angebot.",
    cfFirstName: "Vorname",
    cfLastName: "Nachname",
    cfEmail: "E-Mail",
    cfPhone: "Telefon",
    cfLocation: "Gewünschter Standort",
    cfInquiry: "Anliegen",
    cfChoose: "Bitte wählen",
    cfMessage: "Nachricht",
    cfConsentPre: "Ich habe die ",
    cfConsentLink: "Datenschutzerklärung",
    cfConsentPost: " gelesen und bin damit einverstanden, dass meine Angaben zur Bearbeitung meiner Anfrage verarbeitet werden. *",
    cfSubmit: "Anfrage senden",
    cfSending: "Sende…",
    cfConsentError: "Bitte stimmen Sie der Datenschutzerklärung zu.",
    cfSuccessToast: "Vielen Dank! Wir melden uns zeitnah bei Ihnen.",
    cfSuccessTitle: "Vielen Dank!",
    cfSuccessText: "Ihre Anfrage ist bei uns eingegangen. Wir melden uns zeitnah.",
    cfInqSportbeginn: "Sportbeginn",
    cfInqWiedereinstieg: "Wiedereinstieg nach Pause",
    cfInqHerzcheck: "Herzcheck",
    cfInqBelastung: "Belastungsbeschwerden",
    cfInqFamiliaer: "Familiäre Vorbelastung",
    cfInqAnderes: "Anderes Anliegen",
    // accessibility widget
    a11yTitle: "Barrierefreiheit",
    a11yFontSize: "Schriftgröße",
    a11yContrast: "Hoher Kontrast",
    a11yUnderline: "Links unterstreichen",
    a11yReduceMotion: "Animationen reduzieren",
    a11yReset: "Zurücksetzen",
    a11yOn: "An",
    a11yOff: "Aus",
    a11yOpen: "Barrierefreiheit-Einstellungen öffnen",
    a11yClose: "Schließen",
    a11yFontPlus: "Schrift vergrößern",
    a11yFontMinus: "Schrift verkleinern",
    // cookie banner
    ckTitle: "Datenschutz-Einstellungen",
    ckBody: "Wir verwenden technisch notwendige Cookies. Mit Ihrer Einwilligung nutzen wir zusätzlich Statistik-, Marketing- und externe Medien-Dienste, um unser Angebot zu verbessern. Sie können Ihre Auswahl jederzeit im Footer ändern. Details in unserer ",
    ckPrivacy: "Datenschutzerklärung",
    ckNecessary: "Notwendig",
    ckNecessaryDesc: "Für den Betrieb erforderlich.",
    ckStatistik: "Statistik",
    ckStatistikDesc: "Reichweitenmessung.",
    ckMarketing: "Marketing",
    ckMarketingDesc: "Personalisierte Inhalte.",
    ckExternal: "Externe Medien",
    ckExternalDesc: "Eingebettete Videos / Karten.",
    ckAcceptAll: "Alle akzeptieren",
    ckOnlyNecessary: "Nur notwendige",
    ckSettings: "Einstellungen",
    ckSave: "Auswahl speichern",
    // mobile bottom bar
    mbWriteEmail: "E-Mail schreiben",
    mbCall: "Anrufen",
    mbWhatsApp: "WhatsApp",
  },
  en: {
    requestAppointment: "Request appointment",
    overview: "Overview",
    loading: "Loading …",
    pageNotFound: "Page not found",
    newsNotFound: "News not found",
    allNews: "All news",
    mainNav: "Main navigation",
    mobileNavLabel: "Mobile navigation",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    breadcrumb: "Breadcrumb",
    home: "Home",
    langAria: "Choose language",
    rightsReserved: "All rights reserved.",
    imprint: "Imprint",
    privacy: "Privacy",
    cookieSettings: "Cookie settings",
    cfQuickTitle: "Fastest via WhatsApp or e-mail",
    cfQuickText: "Appointment and contact requests — please not for emergencies. For acute symptoms: emergency number 112.",
    cfPrivateTitle: "Important: private medical service",
    cfPrivateText: "Preventum Diez is a private medical service for privately insured and self-paying patients. Billing through German statutory health insurance is not available.",
    cfPrivateAck: "I understand that this is a private medical service and cannot be billed through German statutory health insurance. *",
    cfPrivateAckError: "Please confirm the notice about the private medical service.",
    cfFirstName: "First name",
    cfLastName: "Last name",
    cfEmail: "E-mail",
    cfPhone: "Phone",
    cfLocation: "Preferred location",
    cfInquiry: "Concern",
    cfChoose: "Please choose",
    cfMessage: "Message",
    cfConsentPre: "I have read the ",
    cfConsentLink: "privacy policy",
    cfConsentPost: " and agree that my details will be processed to handle my request. *",
    cfSubmit: "Send request",
    cfSending: "Sending…",
    cfConsentError: "Please agree to the privacy policy.",
    cfSuccessToast: "Thank you! We will get back to you shortly.",
    cfSuccessTitle: "Thank you!",
    cfSuccessText: "Your request has reached us. We will get back to you shortly.",
    cfInqSportbeginn: "Starting sport",
    cfInqWiedereinstieg: "Return after a break",
    cfInqHerzcheck: "Heart check",
    cfInqBelastung: "Exertion-related symptoms",
    cfInqFamiliaer: "Family history",
    cfInqAnderes: "Other concern",
    a11yTitle: "Accessibility",
    a11yFontSize: "Font size",
    a11yContrast: "High contrast",
    a11yUnderline: "Underline links",
    a11yReduceMotion: "Reduce motion",
    a11yReset: "Reset",
    a11yOn: "On",
    a11yOff: "Off",
    a11yOpen: "Open accessibility settings",
    a11yClose: "Close",
    a11yFontPlus: "Increase font size",
    a11yFontMinus: "Decrease font size",
    ckTitle: "Privacy settings",
    ckBody: "We use technically necessary cookies. With your consent we also use statistics, marketing and external media services to improve our offering. You can change your selection at any time in the footer. Details in our ",
    ckPrivacy: "privacy policy",
    ckNecessary: "Necessary",
    ckNecessaryDesc: "Required for operation.",
    ckStatistik: "Statistics",
    ckStatistikDesc: "Reach measurement.",
    ckMarketing: "Marketing",
    ckMarketingDesc: "Personalised content.",
    ckExternal: "External media",
    ckExternalDesc: "Embedded videos / maps.",
    ckAcceptAll: "Accept all",
    ckOnlyNecessary: "Only necessary",
    ckSettings: "Settings",
    ckSave: "Save selection",
    mbWriteEmail: "Write e-mail",
    mbCall: "Call",
    mbWhatsApp: "WhatsApp",
  },
};

export function isEnPath(pathname) {
  return pathname === "/en" || pathname.startsWith("/en/");
}

// Prefix an internal path with /en when in English. Leaves anchors & external URLs alone.
export function localizePath(path, lang) {
  if (!path || lang !== "en") return path;
  if (/^(https?:|mailto:|tel:|#)/i.test(path) || path.startsWith("wa.me")) return path;
  if (path === "/") return "/en";
  if (path.startsWith("/en/") || path === "/en") return path;
  return "/en" + path;
}

// Toggle a path between languages (for the switcher).
export function switchPath(pathname, toLang) {
  const base = isEnPath(pathname) ? pathname.replace(/^\/en/, "") || "/" : pathname;
  if (toLang === "en") return base === "/" ? "/en" : "/en" + base;
  return base;
}

const LangCtx = createContext({ lang: "de", t: (k) => k, lp: (p) => p });

export function LanguageProvider({ children }) {
  const { pathname } = useLocation();
  const lang = isEnPath(pathname) ? "en" : "de";
  const t = (k) => (UI[lang] && UI[lang][k]) || UI.de[k] || k;
  const lp = (p) => localizePath(p, lang);
  return <LangCtx.Provider value={{ lang, t, lp }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
